import { inject, Service } from '@angular/core';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { LogoutReason } from '@portal-core/auth/enums/logout-reason.enum';
import { Logout } from '@portal-core/auth/services/auth-data.service';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';

/**
 * Navigates to the login route after the user logs out.
 * Listens to the Logout action from the auth data store to navigate to a new route.
 */
@Service()
export class AuthLogoutRedirectEffect {
  private readonly actions$ = inject(Actions);
  private readonly authRouteService = inject(AuthRouteService);

  constructor() {
    this.actions$.pipe(
      ofActionSuccessful(Logout)
    ).subscribe(action => {
      if (action.payload.reason !== LogoutReason.LoginFailure) {
        this.authRouteService.navigateToAuthRoute$(AuthRoute.Login).subscribe();
      }
    });
  }
}
